// extracted by mini-css-extract-plugin
export default {"main":"Navbar_main__C4pV1","logo":"Navbar_logo__7UpMC","links":"Navbar_links__qytUN","preview":"Navbar_preview__nUkfg","see_icon":"Navbar_see_icon__A9tkL"};